import React, { Fragment } from 'react';
import Button from '@material-ui/core/Button';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import SelectionList from '../SelectionList';
import NavigationTabs from '../nav/NavigationTabs';
import { ASSIGN_FEATURED_BRAND_MESSAGE } from '../../static-content';
import { AssignClients } from './../../containers/Assignments';
import { COLORS } from '../../styles/colors';
import { AlertJsMessage } from './../../helpers.js'

class FeaturedBrandForm extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      categoryId: "0",
      tab: 0,
      search: '',
      itemType: 'workout',
      assigns: [],
      dataLoaded: false,
      selectedTab: 'appLibrary',
      selectedItems: {}
    };
  }

  componentDidMount() {
    this.props.fetch().then(() => {
      this.selectAssigned();
      this.setState({ dataLoaded: true });
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.itemType !== this.state.itemType ||
      Object.keys(prevProps.brandDetails).length !== Object.keys(this.props.brandDetails).length) {
      this.selectAssigned();
    }
  }

  selectAssigned = () => {
    const { brandDetails } = this.props;
    let selectedAssignments = {};
    if (Object.values(brandDetails).length) {
      const { itemType } = this.state;
      const key = itemType === 'workout' ? 'workoutList' : 'programList';
      const assigned = brandDetails[key];
      assigned.forEach(assign => selectedAssignments[assign._id] = assign);
    }
    this.setState({ selectedItems: selectedAssignments });
  }

  submitForm() {
    const { selectedItems, itemType } = this.state;
    let selectedIds = Object.keys(selectedItems);
    if (selectedIds.length < 1) {
      AlertJsMessage("Please select a " + itemType + ' from the list to continue.')
      return;
    }

    let data = {
      [`${itemType}s`]: selectedIds
    }
    data.assignUpdate = this.state.itemType;
    this.props.updateBrand(data).then((data) => {
      window.location.reload();
    });
  }

  handleToggleType = (event, type) => {
    if (type) {
      this.setState({
        ...this.state,
        selectedItems: {},
        itemType: type
      })
    }
  }

  renderSelectionList() {
    const { itemType, selectedItems, dataLoaded } = this.state;
    if (dataLoaded) {
      const { workouts, programs, user, workoutCats, programCats, resetWorkouts, resetPrograms, isLoadMoreWorkouts, isLoadMorePrograms } = this.props;
      let items = itemType === 'workout' ? Object.values(workouts) : Object.values(programs);
      let cats = itemType === 'workout' ? Object.values(workoutCats) : Object.values(programCats);
      return (
        <SelectionList
          addSelectedClass={true}
          hideTabs={[1]}
          itemType={itemType}
          items={items}
          selectedItems={selectedItems}
          updateSelectedItems={(selected) => this.setState({ ...this.state, selectedItems: selected })}
          categories={cats}
          categoryField="categoryId"
          creatorTabs={true}
          fetchMore = {this.props.fetchMore}
          resetListing = { itemType === 'workout' ? resetWorkouts : resetPrograms }
          isLoadMore = { itemType === 'workout' ? isLoadMoreWorkouts : isLoadMorePrograms }
          isFeatureBrand = { true}
          user={user}
        />
      )
    }
    return null;
  }

  selectedTab = (path) => {
    this.setState({
        selectedTab: path
    })
}

  renderTabs = () => {

    let links = [
      { text: 'APP LIBRARY', path: 'appLibrary' },
      { text: 'CLIENT LIBRARY', path: 'clientLibrary' },
    ]

    return(<div style={{ width: '100%', borderBottom: '1px solid ' + COLORS.grey, paddingBottom: 6, marginBottom: 20, fontSize: 14 }}>
          {
            links.map((link, i) => (
              <a key={i} >
                <span style={{
                  color: COLORS.black,
                  padding: 6,
                  marginRight: 25,
                  borderBottom: this.state.selectedTab === link.path ? '5px solid ' + COLORS.orange : ''
                }} onClick={() => this.selectedTab(link.path)}>
                  {link.text}
                </span>
              </a>
            ))
          }
    </div>)
  }

  render() {
    const { itemType, selectedTab } = this.state;
   
    return (
      <div>
        {this.renderTabs()}
        {
          selectedTab === 'appLibrary' ?
          <Fragment>
        <NavigationTabs
          hideTabs={true}
          title="Assign"
          subtitle="Featured Brand Page"
          description={ASSIGN_FEATURED_BRAND_MESSAGE}
          set="assign"
          activeRoute="/assign/featured-brand" />
        <div style={{
          marginTop: 25,
          display: 'flex',
          border: '1px solid ' + COLORS.grey
        }}>
          <div style={{ width: '100%', paddingTop: 10, paddingBottom: 10 }}>
            <div style={{ paddingBottom: 10 }}>
              <ToggleButtonGroup value={itemType}
                onChange={this.handleToggleType} exclusive>
                <ToggleButton value='workout' selected={itemType === 'workout'}>
                  Workouts
                </ToggleButton>
                <ToggleButton

                  value="program"
                  selected={itemType === 'program'}>
                  Programs
                </ToggleButton>
              </ToggleButtonGroup>
            </div>

            {this.renderSelectionList()}

            <Button style={{ margin: '0 10px 0 10px' }} onClick={() => this.submitForm()}
              variant="contained" color="primary">
              Assign
            </Button>
          </div>
        </div>
        </Fragment>
        : <AssignClients history={this.props.history} hideTabs={true} isFeatureBrand={true}></AssignClients> }
      </div>
    )
  }
}

export default FeaturedBrandForm;



// WEBPACK FOOTER //
// ./src/components/assignments/FeaturedBrandForm.js